import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ModalService } from '../../services/modal/modal.service';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'app-create-partner',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './create-partner.component.html',
  styleUrl: './create-partner.component.scss',
})
export class CreatePartnerComponent {
  error?: string;
  form!: FormGroup;
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private partnerService: PartnerService,
    private authService: AuthenticationService,
    private modalService: ModalService,
    private vcr: ViewContainerRef,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      name: fb.control('', Validators.required),
      address: fb.control('', Validators.required),
      city: fb.control('', Validators.required),
      pib: fb.control('', Validators.required),
      phone: fb.control(null),
      email: fb.control(null),
      active: fb.control(true, Validators.required),
    });
  }

  createPartner() {
    if (this.form.valid) {
      this.error = undefined;
      this.submitting = true;

      this.partnerService
        .createPartner(this.form.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.submitting = false;

            this.form.reset();
            this.form.controls['active'].setValue(true);

            this.modalService.showSuccessDialog(
              this.vcr,
              'New partner has been created.'
            );
          },
          error: (err: HttpErrorResponse) => {
            if (err.status == 401) {
              this.authService.logout();
            } else {
              this.submitting = false;
              this.error = err.error.message;
            }
          },
        });
    } else {
      this.error = 'Please fill all field properly.';
    }
  }
}
